export default "__VITE_ASSET__BxDiICkc__"